import React from 'react';
import { Badge, Box, Divider, Modal, Stack, Text } from '@mantine/core';
import { EOB } from 'interfaces';
import { getEOBActionTypeColor } from 'utils/badgeColors';

export type DisplayEOB = EOB & {
  tariffLabels?: string[];
};

interface EOBDetailsModalProps {
  opened: boolean;
  eob: DisplayEOB | null;
  onClose: () => void;
  title?: string;
}

export const EOBDetailsModal: React.FC<EOBDetailsModalProps> = ({
  opened,
  eob,
  onClose,
  title = 'EOB Details',
}) => {
  if (!eob) return null;

  return (
    <Modal opened={opened} onClose={onClose} title={title} size="sm" centered>
      <Stack gap="sm">
        <Box>
          <Text size="xs" fw={600} c="dimmed" tt="uppercase">
            Code
          </Text>
          <Badge color={getEOBActionTypeColor(eob.actionType)} variant="filled">
            {eob.code}
          </Badge>
        </Box>

        <Divider />

        <Box>
          <Text size="xs" fw={600} c="dimmed" tt="uppercase">
            Description
          </Text>
          <Text size="sm">{eob.description || '--'}</Text>
        </Box>

        <Box>
          <Text size="xs" fw={600} c="dimmed" tt="uppercase">
            Action Type
          </Text>
          <Text size="sm">{eob.actionType || '--'}</Text>
        </Box>

        <Box>
          <Text size="xs" fw={600} c="dimmed" tt="uppercase">
            Action Description
          </Text>
          <Text size="sm">{eob.actionDescription || '--'}</Text>
        </Box>

        <Box>
          <Text size="xs" fw={600} c="dimmed" tt="uppercase">
            Review Required
          </Text>
          <Text size="sm">{eob.reviewRequired ? 'Yes' : 'No'}</Text>
        </Box>

        {eob.tariffLabels?.length ? (
          <Box>
            <Text size="xs" fw={600} c="dimmed" tt="uppercase" mb={4}>
              Tariff{eob.tariffLabels.length > 1 ? 's' : ''}
            </Text>
            <Stack gap={4}>
              {eob.tariffLabels.map((label) => (
                <Badge key={`${eob.code}-${label}`} variant="light" radius="sm">
                  {label}
                </Badge>
              ))}
            </Stack>
          </Box>
        ) : null}
      </Stack>
    </Modal>
  );
};
